import { render, staticRenderFns } from "./UserImage.vue?vue&type=template&id=f7ee3aee&scoped=true"
import script from "./UserImage.vue?vue&type=script&lang=js"
export * from "./UserImage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f7ee3aee",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/print-suite/source/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f7ee3aee')) {
      api.createRecord('f7ee3aee', component.options)
    } else {
      api.reload('f7ee3aee', component.options)
    }
    module.hot.accept("./UserImage.vue?vue&type=template&id=f7ee3aee&scoped=true", function () {
      api.rerender('f7ee3aee', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/users/UserImage.vue"
export default component.exports